/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
   /* {
        id   : '1',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    },*/
    {
        id: '2',
        title: 'Administración',
        type: 'collapsable',
        icon: 'supervised_user_circle',
        meta: {
            permissions: ['RegistroPago.Menu']
        },
        children: [
            {
                id: '2.1',
                title: 'Pagos',
                type: 'basic',
                link: '/pagos',
                meta: {
                    permissions: ['RegistroPago.Listar']
                }
            },
           /* {
                id: '2.2',
                title: 'Reportar mora',
                type: 'basic',
                link: '/pages/gestion-seguridad/empresas',
            },*/
        ],
    },
    {
        id: '3',
        title: 'Consultas',
        type: 'collapsable',
        icon: 'search',
        meta: {
            permissions: ['Consulta.Menu']
        },
        children: [
            {
                id: '3.1',
                title: 'General',
                type: 'basic',
                meta: {
                    permissions: ['Consulta.Menu']
                },
                link: '/consultas',
            },
           /* {
                id: '2.2',
                title: 'Reportar mora',
                type: 'basic',
                link: '/pages/gestion-seguridad/empresas',
            },*/
        ],
    },
    {
        id: '4',
        title: 'Gestion Visitantes',
        type: 'collapsable',
        icon: 'group',
        meta: {
            permissions: ['Visitante.Menu', 'RegistroVisita.Menu']
        },
        children: [
            {
                id: '4.1',
                title: 'Visitantes',
                type: 'basic',
                link: '/visitantes',
                meta: {
                    permissions: ['Visitante.Listar']
                }
            },
            {
                id: '4.2',
                title: 'Visitas',
                type: 'basic',
                link: '/visitas',
                meta: {
                    permissions: ['RegistroVisita.Listar']
                }
            },
            {
                id: '4.3',
                title: 'Lectura de Qr',
                type: 'basic',
                link: 'visitantes/leer-qr',
                meta: {
                    permissions: ['RegistroVisita.Crear']
                }
            },
        ],
    },
    {
        id: '5',
        title: 'Gestion Propiedades',
        type: 'collapsable',
        icon: 'home',
        meta: {
            permissions: ['Propiedad.Menu', 'TipoPropiedad.Menu']
        },
        children: [
            {
                id: '5.1',
                title: 'Propiedades',
                type: 'basic',
                link: 'propiedades',
                meta: {
                    permissions: ['Propiedad.Listar']
                },
            },
            {
                id: '5.2',
                title: 'Tipos de propiedades',
                type: 'basic',
                link: 'tipos-propiedades',
                meta: {
                    permissions: ['TipoPropiedad.Listar']
                },
            },

        ]
    },
    {
        id: '6',
        title: 'Seguridad',
        type: 'collapsable',
        icon: 'lock',
        meta: {
            permissions: ['Usuario.Menu']
        },
        children: [
            {
                id: '6.1',
                title: 'Usuarios',
                type: 'basic',
                link: 'seguridad/usuarios',
                meta: {
                    permissions: ['Usuario.Listar']
                },
            },
            {
                id: '6.2',
                title: 'Roles',
                type: 'basic',
                link: 'seguridad/roles',
                meta: {
                    permissions: ['Usuario.Listar']
                },
            },
        ],
    },
   /* {
        id: '6',
        title: 'Reportes',
        type: 'collapsable',
        icon: 'assignment',
        children: [
            {
                id: '6.1',
                title: 'Usuarios',
                type: 'basic',
                link: '/pages/gestion-seguridad/empresas',
            },
        ],
    },*/
    /*{
        id: '7',
        title: 'Configuración',
        type: 'collapsable',
        icon: 'settings',
        children: [
            {
                id: '7.1',
                title: 'Parametros',
                type: 'basic',
                link: '',
            },
        ],
    },*/
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
